import { Badge, Card, Col, Container, Row } from "react-bootstrap";
import { KeyFill, QrCode } from "react-bootstrap-icons";
import { useLoaderData, useNavigate } from "react-router-dom";
import { PageTitle } from "./Controls/PageTitle";
import { facilityImg } from "./Data/Common";
import { ServerTransferConnectSubListEntry, SubscriptionApi } from "./shared/api/axios-client";
import { useAtomValue } from "jotai";
import { authAtom } from "./Data/Atoms";
import { SubscriptionStatusPill } from "./Controls/SubscriptionStatusPill";
import QrCodeModal from "./Controls/QRCodeModal";
import { useState } from "react";
import { createApiService } from "./shared/apiConfig";

const subscriptionApi = createApiService(SubscriptionApi)

export function UserAccessCodePage() {
    const nav = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const auth = useAtomValue(authAtom);
    const [qrCode, setQrCode] = useState('')
    const subs = useLoaderData() as ServerTransferConnectSubListEntry[];
    const callQrCode = (sub: ServerTransferConnectSubListEntry)=>{
        subscriptionApi.getParkerAccessCode({
            parkerId: auth.account?.parkerId!,
            subscriptionId: sub.subscriptionId!
        }).then((accessCode)=>{
            const response = accessCode.data as any
            setQrCode(response.metaFlashRFIDNumber)
            setShowModal(true)
        }).catch(()=>{

        })
    }


    return <Container fluid>
        <Row>
            <Col>
                <PageTitle>
                    Access Passes
                </PageTitle>
                <div
                    className="rounded-3 d-flex align-items-center gap-2 mb-3 mt-1 px-3 py-2"
                    style={{ backgroundColor: 'var(--color-light)' }}
                >
                    <div
                        className="rounded flex-shrink-0 d-flex align-items-center justify-content-center text-white"
                        style={{ width: 40, height: 40, backgroundColor: 'var(--color-mid)' }}
                    >
                        <KeyFill className="fs-5" />
                    </div>
                    <div className="small" style={{ color: 'var(--color-very-dark)' }}>
                        Gate & Entry Access — tap a pass below to show your QR code for the scanner.
                    </div>
                </div>
                {subs.length === 0 && <>
                    You don't have any access passes
                </>}
                {subs.map(sub => {
                    const facility = sub.facility;
                    const quantity = sub.quantity;
                    const price = sub.price;
                    const notMine = sub.parkerId != auth.account!.parkerId;
                    const spots = sub.quantity;

                    return <Card key={sub.subscriptionId} className="mb-3" style={{ cursor: "pointer" }}
                        onClick={() => callQrCode(sub)}>
                        <Card.Header className="text-start d-flex align-items-center justify-content-between gap-2 py-1">
                            <span className="d-flex align-items-center gap-1">
                                {notMine && <Badge className="bg-primary">Guest</Badge>}
                                <SubscriptionStatusPill status={sub.status!} />
                            </span>
                            <span className="text-muted small text-end">{sub.plan?.name}</span>
                        </Card.Header>
                        <Card.Body className="purchase-layout gap-2">
                            <div className="grid-area-a">
                                <img className="facility-result-pic"
                                    src={facilityImg(facility?.listImageId!)}
                                    style={{ aspectRatio: "1 / 1", objectFit: "cover" }} />
                            </div>
                            <div className="grid-area-b">
                                <div className="fw-bold">
                                    {sub.facility?.name}
                                </div>
                            </div>
                            <div className="grid-area-c position-relative" style={{ justifySelf: "end" }}>

                                
                            </div>
                            <div className="grid-area-d text-end d-flex gap-2">
                                <button
                                    type="button"
                                    className="rounded-4 border-primary border-2 status-btn text-black d-flex align-items-center justify-content-center btn btn-body-secondary"
                                >
                                    <QrCode className="me-2"/> Get QR Code 
                                </button>
                            </div>
                        </Card.Body>
                    </Card>;
                })}
            </Col>
        </Row>
        <QrCodeModal
            show={showModal}
            onHide={() => setShowModal(false)}
            value={qrCode}
            height={256}
        />
    </Container>;

}